module.exports = __webpack_public_path__ + "static/img/goods_icon_suipian@2x.2428ee9b.png";